module.exports = __webpack_public_path__ + "media/evolve/assets/icons/static/info-aa79962cf6c647cd30dd2aea994ee3a9.svg";